import React from 'react';
import { Box, Container, Typography, Paper, Link, List, ListItem, ListItemText, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(10px)',
  borderRadius: '15px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
}));

const Datenschutz = () => {
  return (
    <Container maxWidth="md">
      <StyledPaper>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Datenschutzerklärung
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Verantwortlicher
        </Typography>

        <Typography paragraph>
          Hermann Huber<br />
          Jägerstraße 14<br />
          72213 Altensteig<br />
          Deutschland
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Allgemeine Hinweise
        </Typography>
        
        <Typography paragraph>
        Diese Datenschutzerklärung klärt Besucher meiner privaten Website über die Art, den Umfang und den Zweck der Erhebung und Verwendung personenbezogener Daten auf.
        Ich beachte dabei die Vorgaben der Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG).
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Rechtsgrundlagen der Verarbeitung
         </Typography>

        
        <Typography paragraph>
         Einwilligung (Art. 6 Abs. 1 lit. a DSGVO),  
         Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO), z. B. bei Log-Dateien zur Gewährleistung des Betriebs der Website,  
         Erfüllung rechtlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO).
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Erhobene Daten und Verarbeitungszweck
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          4.1 Server Logfiles
        </Typography>
        
        <Typography paragraph>
          Beim Aufruf der Website werden automatisch folgende Informationen an den Server übermittelt und für maximal 7 Tage gespeichert:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="IP-Adresse (anonymisiert oder gekürzt, sofern technisch möglich)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Datum und Uhrzeit des Zugriffs" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="aufgerufene URL" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Referrer (vorher besuchte Seite)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Browsertyp und -version, Betriebssystem" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Hostname des zugreifenden Rechners" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
        </List>

        <Typography paragraph>
          Die Daten werden zur Gewährleistung eines störungsfreien Betriebs, Analyse der Systemsicherheit und -stabilität verarbeitet.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          4.2 E-Mail-Kontakt
        </Typography>

        <Typography paragraph>
        Bei direktem E-Mail-Kontakt werden folgende Daten erhoben:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Name" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="E-Mail-Adresse" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Betreff, Nachrichtentext" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Datum und Uhrzeit der Anfrage" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
        </List>

        <Typography paragraph>
        Die Daten werden ausschließlich zur Bearbeitung deiner Anfrage verwendet und nach Abschluss gelöscht, sofern keine gesetzlichen Aufbewahrungsfristen bestehen.          
        </Typography>
        
        <Typography variant="subtitle1" gutterBottom>
          4.3 Cookies
        </Typography>

        <Typography paragraph>
         Diese Website verwendet keine Tracking-Cookies.
         Session-Cookies, die für die Darstellung der Seite erforderlich sind, werden nur temporär für Dauer deines Besuchs gespeichert und nach dem Schließen deines Browsers gelöscht.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          4.4 Webanalyse mit Umami
        </Typography>

        <Typography paragraph>
          Diese Webseite nutzt das Open-Source-Webanalyse-Tool <strong>Umami</strong>, um das Nutzungsverhalten auf unserer Website <strong>anonymisiert</strong> auszuwerten.
          Die Daten helfen uns zu verstehen, welche Seiten besonders häufig besucht werden und wie sich Besucher auf unserer Website bewegen.
          Dabei werden <strong>keine Cookies gesetzt</strong> und <strong>keine personenbezogenen Daten</strong> wie IP-Adressen gespeichert.
          Alle erhobenen Informationen sind vollständig anonymisiert und lassen keinen Rückschluss auf einzelne Personen zu.
          Die Verarbeitung erfolgt auf Grundlage von <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> (berechtigtes Interesse). 
          Unser Interesse liegt in der Verbesserung unseres Online-Angebots und der technischen Optimierung der Website.
          Umami wird von uns selbst auf einem eigenen Server in Deutschland betrieben. Es erfolgt <strong>keine Übermittlung der Daten an Dritte</strong>.
        </Typography>
        
        <Typography variant="subtitle1" gutterBottom>
          4.5 Social Media Plugins
        </Typography>

        <Typography paragraph>
         Auf der Webseite kommen keine Social Media Plugins zum Einsatz.
         Es werden keine Social-Buttons oder eingebetteten Inhalte (Embed-Posts, Like-Buttons) genutzt.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Weitergabe von Daten an Dritte
        </Typography>
        
        <Typography paragraph>
        Eine Weitergabe deiner personenbezogenen Daten an Dritte findet nicht statt, außer:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="du hast ausdrücklich eingewilligt (Art. 6 Abs. 1 lit. a DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="ich bin gesetzlich dazu verpflichtet (z. B. Auskunftsersuchen von Behörden)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="die Weitergabe ist zur Durchsetzung meiner Rechte erforderlich" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
        </List>

        <Typography variant="h6" gutterBottom>
          6. Speicherdauer
        </Typography>

        <Typography paragraph>
        Ich speichere deine Daten nur so lange, wie es für die Bereitstellung der Leistung und die Abwicklung von Anfragen erforderlich ist.
        Dir stehen stets folgende Rechte zu:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Berichtigung unrichtiger Daten (Art. 16 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary='Löschung ("Recht auf Vergessenwerden", Art. 17 DSGVO)' primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Einschränkung der Verarbeitung (Art. 18 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Datenübertragbarkeit (Art. 20 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Widerspruch gegen Verarbeitung auf Basis berechtigter Interessen (Art. 21 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)" primaryTypographyProps={{ sx: { '&::before': { content: '"•"', marginRight: 1 } } }} />
          </ListItem>
        </List>

        <Typography variant="h6" gutterBottom>
          7. Widerspruchsrecht
        </Typography>

        <Typography paragraph>
         Möchtest du der Verarbeitung deiner Daten widersprechen, sende bitte eine E-Mail an <Link href="mailto:hermann@cyberlagebild.de" sx={{ color: '#ff8c00' }}>hermann@cyberlagebild.de</Link>. 
         Ich werde die Verarbeitung einstellen, sofern keine zwingenden schutzwürdigen Gründe entgegenstehen. 
         </Typography>

        <Typography variant="h6" gutterBottom>
          8. Datensicherheit
        </Typography>

        <Typography paragraph>
        Ich ergreife angemessene technische und organisatorische Maßnahmen, um deine Daten vor Verlust, Missbrauch und unbefugtem Zugriff zu schützen (z. B. TLS-Verschlüsselung, regelmäßige Updates).
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Aktualität und Änderung dieser Datenschutzerklärung
        </Typography>

        <Typography paragraph>
        Diese Erklärung ist aktuell gültig ab Mai 2025. Durch Weiterentwicklung der Website oder Änderung der rechtlichen Rahmenbedingungen kann es erforderlich werden, die Erklärung zu ändern.
        Die jeweils aktuelle Version findest du stets hier auf der Website.
        </Typography>
        
      </StyledPaper>
      <Button
        component={RouterLink}
        to="/"
        startIcon={<ArrowBackIcon />}
        sx={{ mt: 2, color: '#ff8c00' }}
      >
        Zurück zur Startseite
      </Button>
    </Container>
  );
};

export default Datenschutz; 